// extracted by mini-css-extract-plugin
export var readonly = "_eu-1";
export var star = "_eu-0";